import { Component, Input } from '@angular/core';
import { OptionAutomatiqueConseil } from '@lib/models/generated/graphql';
import { Subscription } from 'rxjs';
import { FicheConseilService } from 'src/app/services/fiche-conseil.service';
import { FormConfigService } from 'src/app/services/form-config.service';
import { FieldFormControl } from 'src/fieldFormControl/FieldFormControl';

@Component({
  selector: 'app-option-checkbox',
  templateUrl: './option-checkbox.component.html',
  styleUrls: ['./option-checkbox.component.scss'],
})
export class OptionCheckboxComponent {
  protected optionAuto: OptionAutomatiqueConseil;
  @Input({ required: true }) set option(value: OptionAutomatiqueConseil) {
    this.optionAuto = value;
    this.initData();
  }

  control: FieldFormControl<boolean, OptionAutomatiqueConseil>;
  ficheSub: Subscription;

  constructor(protected ficheConseilService: FicheConseilService, protected formConfigService: FormConfigService) {}

  ngOnDestroy() {
    this.ficheSub?.unsubscribe();
  }

  initData() {
    this.ficheSub?.unsubscribe();
    this.control = new FieldFormControl<boolean, OptionAutomatiqueConseil>({
      formConfigService: this.formConfigService,
      ficheConseilService: this.ficheConseilService,
      dataKey: 'optionsAutomatiques',
      ficheDataToFieldDataWrapper: (data: any) => data?.isSelected,
      fieldDataToFicheDataWrapper: (fieldData: boolean) => {
        const updatedOption: OptionAutomatiqueConseil = {
          id: this.optionAuto.id,
          libelle: this.optionAuto.libelle,
          isSelected: fieldData,
        };
        return updatedOption;
      },
      arrayItemSelector: (data: OptionAutomatiqueConseil) => {
        const optionId = this.optionAuto?.id;
        const ficheOptionId = data?.id;
        return data && this.optionAuto && optionId === ficheOptionId;
      },
      options: { nonNullable: true },
      defaultValue: false,
    });

    this.ficheSub = this.ficheConseilService.currentFicheConseilSubject.subscribe(currentFiche => {
      const ficheOptions = currentFiche?.optionsAutomatiques;
      if (ficheOptions) {
        const selectedOptions = ficheOptions.filter(option => option.isSelected);
        if (selectedOptions.length > 1 && !this.control?.value) {
          this.control?.disable();
        } else {
          this.control?.enable();
        }
      }
    });
  }
}
